import { render } from "./SoldGrow.vue?vue&type=template&id=b466179c"
import script from "./SoldGrow.vue?vue&type=script&lang=js"
export * from "./SoldGrow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__